//NPM
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

// Actions, Services, Selectors
import * as actions from 'actions';

// Components
import { Modal } from 'frontend-component-library';

export default function WrapInModal(WrappedComponent, modalName) {
  class ModalWrapper extends PureComponent {
    render() {
      const { isOpen, closeModal, className } = this.props;
      return (
        <Modal isOpen={isOpen} className={className} closeModal={closeModal}>
          <WrappedComponent {...this.props} />
        </Modal>
      );
    }
  }

  ModalWrapper.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    updateModal: PropTypes.func.isRequired,
  };

  ModalWrapper.defaultProps = {
    isOpen: false,
  };

  function mapStateToProps(state, props) {
    const { name, isOpen, props: modalProps } = state.openModal;
    if (name === modalName && isOpen) {
      return {
        ...modalProps,
        isOpen,
      };
    } else {
      return { isOpen: false };
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        updateModal: actions.openModal.bind(null, modalName),
        closeModal: actions.closeModal,
      },
      dispatch
    );
  }

  return connect(mapStateToProps, mapDispatchToProps)(ModalWrapper);
}



// WEBPACK FOOTER //
// ./src/Components/ModalWrapper.js